import { useCallback } from 'react';
import { betStore, notificationStore, userInfoStore } from '@pascal/pascal-core';
import { betDataStore, doBetStore, gameStore, oddStore } from '../store';
import { defaultMinOdd } from '../enums/gameConstants';

export const useDemoSwitcher = () => {
  const demoSwitcherAdditionalFunction = useCallback(() => {
    const { partnerWageringOdd, setMinOdd, setDefaultMinOdd, allGameTypes } = gameStore;
    const realAllBets = betStore.liveBets.filter((bet) => bet.playerExternalId);

    betStore.setLiveBets(realAllBets);
    doBetStore.resetDoBetData(allGameTypes);
    betDataStore.resetBetData(allGameTypes);
    oddStore.resetDemoCurrentBetAmount(allGameTypes);
    userInfoStore.setDemoInitialBalance();
    notificationStore.setNotificationType({});
    if (partnerWageringOdd) {
      setMinOdd(partnerWageringOdd);
      if (partnerWageringOdd > defaultMinOdd) {
        setDefaultMinOdd(partnerWageringOdd);
        betDataStore.setAutoCashOutOdd(partnerWageringOdd);
      }
    }
    const realMyBets = realAllBets.filter(
      (bet) => bet.playerExternalId === userInfoStore.playerExternalId
    );

    realMyBets.forEach(({ gameTypeId, ...rest }) => {
      doBetStore.setInitialDefaultDoBetData(gameTypeId, rest);
      oddStore.setCurrentBetAmount(rest.amount, gameTypeId);
    });
  }, []);

  return { demoSwitcherAdditionalFunction };
};
